import React, { useState, useEffect } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";

import {
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Text,
  Box,
  FormLabel,
} from "@chakra-ui/react";
import { CustomButton } from "../../../../../components/CustomButton";
import { FocusError } from "../../../../../components/FocusError";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import turnToPascalCase from "../../../../../utils/turnToPascal";

import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { IrmaoTable } from "../../../ReferenciaFamiliar/Irmaos/Table";
import { IoAlertCircleOutline } from "react-icons/io5";
import { normalizeString } from "../../../../../utils/masks";
import CriancaService from "../../../../../../main/services/CriancaService";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { useAuth } from "react-oidc-context";
import { useHistory } from "react-router-dom";

const schema = Yup.object().shape({
  idPessoaFisica: Yup.number().required("Este campo é obrigatório!"),
});

export const FiliacaoModalUnify = ({
  isOpen,
  onClose,
  onCloseSearch,
  idCrianca,
  columnsEntregaCadastrar,
  data,
  selected,
  alerta,
  nome,
  setFieldValue,
  setData,
  valuesModal,
}) => {
  const { setCadastrarProcessosProcedimentos, setIdPessoaFisicaFilho } =
    useAppContext();
  const [loading, setLoading] = useState(false);
  const [initialValues] = useState({
    idPessoaFisica: "",
  });
  const keycloak = useAuth();
  const history = useHistory();

  const [, setTempSelected] = useState();
  const [, setTreatedData] = useState();

  const backAlert = () => {
    setFieldValue("filiacoes", [selected]);
    setIdPessoaFisicaFilho(null);
    onClose();
    onCloseSearch();
  };

  function appendPaisToData(filhos, pessoasFisicas) {
    return pessoasFisicas.map((pessoa) => {
      const matchingFilho = filhos?.find(
        (filho) => filho.idPessoaFisicaFilho === pessoa.idPessoaFisica
      );
      if (matchingFilho) {
        return {
          ...pessoa,
          pais: matchingFilho.pais,
          idCriancaFilho: matchingFilho.idCriancaFilho,
        };
      }
      return pessoa;
    });
  }

  const mensagem = () => {
    let nomePais;

    const dataPais = appendPaisToData(selected?.criancasAgrupadasPais, data);

    const nomeFilhoDuplicadoDados = dataPais?.find(
      (crianca) =>
        normalizeString(crianca.nome) === normalizeString(nome) &&
        crianca.idCriancaFilho === null
    );

    if (data && data.length === 1) {
      if (nomeFilhoDuplicadoDados?.pais) {
        if (nomeFilhoDuplicadoDados?.pais?.length === 1) {
          nomePais = `${nomeFilhoDuplicadoDados?.pais[0].nome} (${nomeFilhoDuplicadoDados?.pais[0].tipoFiliacao})`;
        } else {
          const pais = nomeFilhoDuplicadoDados?.pais
            .slice(0, -1)
            .map((pai) => `${pai.nome} (${pai.tipoFiliacao})`)
            .join(", ");

          const ultimoPai =
            nomeFilhoDuplicadoDados?.pais[
              nomeFilhoDuplicadoDados?.pais?.length - 1
            ];
          nomePais = `${pais} e ${ultimoPai.nome} (${ultimoPai.tipoFiliacao})`;
        }
      } else {
        nomePais = `${selected?.nome} ${
          selected?.tipoFiliacao ? `(${selected?.tipoFiliacao})` : ""
        }`;
      }

      return (
        <Text>
          Existe um cadastro{" "}
          {`${nomeFilhoDuplicadoDados ? "de" : "semelhante ao de"}`}{" "}
          <Box as="b">{nome ? turnToPascalCase(`${nome}`) : ""}</Box>
          {nomePais
            ? ` associado a
          filiação ${nomePais}`
            : ""}
          .
        </Text>
      );
    } else if (data && data.length > 1) {
      if (
        nomeFilhoDuplicadoDados &&
        nomeFilhoDuplicadoDados[0]?.pais?.length > 0
      ) {
        if (nomeFilhoDuplicadoDados?.pais?.length === 1) {
          nomePais = `${nomeFilhoDuplicadoDados?.pais[0]?.nome} (${nomeFilhoDuplicadoDados?.pais[0]?.tipoFiliacao})`;
        } else {
          const pais = nomeFilhoDuplicadoDados?.pais
            .slice(0, -1)
            .map(
              (pai) =>
                `${pai?.nome ? pai?.nome : ""} (${
                  pai?.tipoFiliacao ? pai?.tipoFiliacao : ""
                })`
            )
            .join(", ");

          const ultimoPai =
            nomeFilhoDuplicadoDados?.pais[
              nomeFilhoDuplicadoDados?.pais?.length - 1
            ];
          nomePais = `${pais ? pais : ""} e ${
            ultimoPai?.nome ? ultimoPai?.nome : ""
          } (${ultimoPai?.tipoFiliacao ? ultimoPai?.tipoFiliacao : ""})`;
        }
      } else {
        nomePais = `${selected?.nome ? selected?.nome : ""} ${
          selected?.tipoFiliacao ? `(${selected?.tipoFiliacao})` : ""
        }`;
      }
      return (
        <Text>
          Existem cadastros semelhantes ao de{" "}
          <Box as="b">{nome ? turnToPascalCase(`${nome}`) : ""}</Box>
          {nomePais
            ? ` associados a
          filiação ${nomePais}`
            : ""}
          .
        </Text>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (data) {
      setTreatedData(data);
    } else {
      setTreatedData(null);
    }
    setTempSelected(null);
  }, [data]);

  const handleSubmit = (values, actions) => {
    setLoading(true);
    setTimeout(() => {
      const { idPessoaFisica } = values;

      const filhosComCadastro = data?.filter(
        (filho) =>
          Number(filho.idPessoaFisica) === Number(idPessoaFisica) &&
          filho.temCadastroCrianca === true
      );

      if (filhosComCadastro && filhosComCadastro.length > 0) {
        setLoading(false);
        actions.setSubmitting(false);

        const crianca = filhosComCadastro[0];

        const valuesToSendValid = {
          nome: crianca.nome?.trim() || "",
          nomeSocial: "",
          idGenero: crianca.idGenero || null,
          indicadorNomeNaoInformado: "N",
          idCrianca: null,
          nomeUsuarioLogado: keycloak.user?.profile?.name || "",
          dataNascimento: crianca.dataNascimento
            ? new Date(crianca.dataNascimento).toISOString()
            : "",
        };

        CriancaService.validCrianca(valuesToSendValid).catch((error) => {
          Swal.fire({
            title: "Atenção!",
            text: error.response?.data?.message || "Erro ao validar criança",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            history.push(`/crianca`);
          });
        });

        return;
      }

      const nomeFilhoDuplicadoDados = selected?.criancasAgrupadasPais?.find(
        (crianca) =>
          Number(crianca?.idPessoaFisicaFilho) === Number(idPessoaFisica) &&
          crianca.idCriancaFilho === null
      );
      const date = new Date(nomeFilhoDuplicadoDados?.dataNascimentoFilho);
      const formattedDate = format(date, "dd/MM/yyyy");

      setIdPessoaFisicaFilho(idPessoaFisica ? idPessoaFisica : null);

      nomeFilhoDuplicadoDados.pais = nomeFilhoDuplicadoDados?.pais?.map(
        (paiOuMae) => {
          const updatedPaiOuMae = {
            ...paiOuMae,
            idEstado: paiOuMae.estado,
            idMunicipio: paiOuMae.municipio,
            idBairro: paiOuMae.bairro,
          };

          return updatedPaiOuMae;
        }
      );

      const filiacoesChangeFilter = valuesModal.filiacoes.filter(
        (filiacao) =>
          !nomeFilhoDuplicadoDados?.pais.some(
            (paiOuMae) => paiOuMae.tipoFiliacao === filiacao.tipoFiliacao
          )
      );
      const filiacoesAtualizadas = [
        ...filiacoesChangeFilter,
        ...nomeFilhoDuplicadoDados?.pais,
      ];
      setFieldValue("filiacoes", filiacoesAtualizadas);
      nomeFilhoDuplicadoDados?.dataNascimentoFilho &&
        setFieldValue("dataNascimento", formattedDate);
      setFieldValue("nome", nomeFilhoDuplicadoDados?.nomeFilho);

      setData(null);
      onClose();
      onCloseSearch();
      setLoading(false);
      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "100%" }}
          maxWidth="450px"
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            <Flex
              w="full"
              justifyContent={"center"}
              alignItems="center"
              flexDirection="column"
              gap={2}
            >
              <IoAlertCircleOutline color="#f8bb86" size={90} />
              <Text color="black" fontWeight={500} fontSize={"24px"}>
                Atenção!
              </Text>
            </Flex>
          </ModalHeader>

          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarProcessosProcedimentos(
                    hasFormChanged(initialValues, props.values)
                  )}

                  <FocusError />

                  <Grid templateColumns="repeat(3, 1fr) 1fr">
                    <GridItem colSpan={7}>
                      <Text
                        color="black"
                        fontWeight={500}
                        textAlign="justify"
                        fontSize={"14px"}
                      >
                        {mensagem()}
                      </Text>
                    </GridItem>

                    {!alerta && (
                      <GridItem colSpan={4}>
                        <FormLabel
                          py="2"
                          m={0}
                          mt={4}
                          px={4}
                          color="black"
                          width="full"
                          fontSize="14px"
                          htmlFor={"irmaos"}
                        >
                          {data && data.length > 1
                            ? "Selecione uma das opções abaixo caso deseje unificar os dados."
                            : "Selecione a opção abaixo caso deseje unificar os dados."}
                        </FormLabel>
                        <IrmaoTable
                          disableHeaderOptions={true}
                          disableHeaderOptionsOpcoes={true}
                          mt={"0px"}
                          props={props}
                          columns={columnsEntregaCadastrar}
                          data={data}
                          filiacoes={data}
                          entidade="entrega"
                          duplicidade={true}
                          entregaCadastrar={true}
                          entrega={true}
                          idCrianca={idCrianca}
                        />
                      </GridItem>
                    )}
                  </Grid>

                  <Flex justifyContent="end" gap={2} mt={6}>
                    <CustomButton onClick={onClose} label="Cancelar" />
                    <CustomButton
                      type="submit"
                      translate="no"
                      isLoading={props.isSubmitting || loading}
                      isDisabled={!props.values.idPessoaFisica}
                      label="Selecionar"
                    />
                    <CustomButton
                      onClick={backAlert}
                      label="Prosseguir sem Unificar"
                    />
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
